import React from "react";

import { visibilityStore } from "./store/VisibilityStore";
import { Container } from "../Container";
import { VisibilityVirtual, IProps } from "./VisibilityVirtual";

export const VisibilityVirtualWidget = (props: IProps): JSX.Element => (
	<Container store={visibilityStore}>
		<VisibilityVirtual {...props} />
	</Container>
);
